import { Injectable } from '@angular/core';
import {
  BaseService,
  Playoff,
  Tournament,
  TournamentApi,
  TournamentGroup,
  TournamentRound,
  TournamentRoundApi,
  TournamentRoundTeam,
  TournamentRoundTypes,
  TournamentSeasonApi
} from '@mtgame/core';
import { Observable } from 'rxjs';

const STORE_ROUNDS_KEY = 'rounds';
const STORE_SELECTED_ROUND_KEY = 'selectedRound';
const STORE_GROUPS_KEY = 'groups';
const STORE_PLAYOFFS_KEY = 'playoffs';

@Injectable()
export class TournamentWidgetService extends BaseService {
  private tournament: Tournament;
  tournamentId: number;

  get rounds$(): Observable<TournamentRound[]> {
    return this.store.get(STORE_ROUNDS_KEY);
  }

  get groups$(): Observable<TournamentGroup[]> {
    return this.store.get(STORE_GROUPS_KEY);
  }

  get playoffs$(): Observable<Playoff[]> {
    return this.store.get(STORE_PLAYOFFS_KEY);
  }

  get selectedRound$(): Observable<TournamentRound> {
    return this.store.get(STORE_SELECTED_ROUND_KEY);
  }

  constructor(
    private tournamentSeasonApi: TournamentSeasonApi,
    private tournamentApi: TournamentApi,
    private tournamentRoundApi: TournamentRoundApi,
  ) {
    super();
  }

  async initialize(tournament: Tournament): Promise<any> {
    this.tournament = tournament;
    this.tournamentId = tournament.id;
    const rounds = await this.getRounds();
    if (rounds.length > 0) {
      await this.setRound(tournament.sport.isHockey() ? rounds[0] : rounds[rounds.length - 1]);
    }
  }

  async getRounds(): Promise<TournamentRound[]> {
    const rounds = await this.tournamentApi.getTournamentRounds(this.tournamentId);
    this.store.save(STORE_ROUNDS_KEY, this.tournament.sport.isHockey() ? rounds.reverse() : rounds);
    return rounds;
  }

  async setRound(round: TournamentRound): Promise<any> {
    this.store.save(STORE_SELECTED_ROUND_KEY, round);
    if (round.type === TournamentRoundTypes.playoff) {
      await this.getPlayoffs(round.id);
    } else if (round.type === TournamentRoundTypes.group) {
      await this.getGroups(round.id);
    }
  }

  async getGroups(roundId: number): Promise<TournamentGroup[]> {
    const groups = await this.tournamentRoundApi.getGroups(roundId);
    this.store.save(STORE_GROUPS_KEY, groups);
    return groups;
  }

  async getPlayoffs(roundId: number): Promise<Playoff[]> {
    const playoffs = await this.tournamentRoundApi.getPlayoffs(roundId);
    this.store.save(STORE_PLAYOFFS_KEY, playoffs);
    return playoffs;
  }
}
